import React, { useState } from "react";
import { Tooltip, IconButton, TableCell } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DownloadIcon from "@mui/icons-material/Download";
import { PiSignatureFill } from "react-icons/pi";
import { enqueueSnackbar } from "notistack";
import axios from "../../../configApi/axiosConfig";
import { APIURL } from "../../../configApi/apiConfig";
import { firmaElectronicaIcons, tipoFirmaElectronicaIcons } from "../ListadoSolicitud.iconMaps";

// Columna "Digital": ícono/estado de firma electrónica, habilitado para abrir
// el modal de firma solo cuando `puedeFirmar` es true.
export default function CeldaDigital({ data, puedeFirmar, puedeDescargarDocumentosBS, handleOpenFirmaElectronica, handlePopoverOpen }) {
  const firmaIcon = firmaElectronicaIcons[data.idFirmaElectronica] || firmaElectronicaIcons[0];
  const [isDescargando, setIsDescargando] = useState(false);

  // Banco Solidario, firma completada y usuario con permiso "DESCARGAR
  // DOCUMENTOS BANCO SOLIDARIO": se puede descargar el ZIP con los 9
  // documentos firmados + endoso + informe telefónico + informe de domicilio
  // (este último best-effort, ver documentos-estado en el backend).
  const puedeDescargarZipBS =
    data.TipoFirmaElectronica === 2 && data.idFirmaElectronica === 6 && puedeDescargarDocumentosBS?.();

  const handleDescargarZip = async (event) => {
    event.stopPropagation();
    if (isDescargando) return;
    setIsDescargando(true);
    try {
      const [estadoResp, zipResp] = await Promise.all([
        axios.get(APIURL.getDocumentosEstadoBancoSolidario(data.id)).catch(() => null),
        axios.get(APIURL.getDocumentosZipBancoSolidario(data.id), { responseType: "blob" }),
      ]);

      const blobUrl = URL.createObjectURL(new Blob([zipResp.data], { type: "application/zip" }));
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = `documentos-banco-solidario-${data.NumeroSolicitud || data.id}.zip`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(blobUrl);

      if (estadoResp?.data?.terrenaDisponible === false) {
        enqueueSnackbar(
          estadoResp.data?.terrenaMotivo || "Aún no se ha realizado la verificación de domicilio.",
          { variant: "warning" }
        );
      }
    } catch (error) {
      console.error("Error al descargar documentos de Banco Solidario:", error);
      enqueueSnackbar("No se pudo descargar el ZIP de documentos.", { variant: "error" });
    } finally {
      setIsDescargando(false);
    }
  };

  return (
    <TableCell align="center">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
        }}
      >
        {tipoFirmaElectronicaIcons[data.TipoFirmaElectronica] && (
          <Tooltip
            title={
              data.Estado === 6 ? firmaIcon.tooltip : tipoFirmaElectronicaIcons[data.TipoFirmaElectronica]?.tooltip
            }
            arrow
            placement="top"

          >
            <span>
              <IconButton
                size="small"
                disabled={!puedeFirmar}
                onClick={
                  puedeFirmar
                    ? () => handleOpenFirmaElectronica(data)
                    : undefined
                }
                sx={{
                  bgcolor: firmaIcon.color,
                  color: firmaIcon.color,
                  "&:hover": {
                    bgcolor: firmaIcon.color || "#e2e8f0",
                    transform: firmaIcon.color ? "scale(1.1)" : "none",
                  },
                  transition: "all 0.2s ease",
                }}
              >
                {data.TipoFirmaElectronica === 2 && data.idFirmaElectronica === 1
                  ? <PiSignatureFill size={25} color="#0891b2" />
                  : firmaIcon.icon}
              </IconButton>
            </span>
          </Tooltip>
        )}

        {puedeDescargarZipBS && (
          <Tooltip title="Descargar todos los documentos (ZIP)" arrow placement="top">
            <span>
              <IconButton size="small" disabled={isDescargando} onClick={handleDescargarZip}>
                <DownloadIcon fontSize="small" style={{ opacity: isDescargando ? 0.5 : 1 }} />
              </IconButton>
            </span>
          </Tooltip>
        )}

        <MoreVertIcon
          onClick={(event) => handlePopoverOpen(event, 11, data)}
          style={{ cursor: "pointer" }}
          className="text-slate-400 hover:text-slate-600 transition-colors duration-200"
        />
      </div>
    </TableCell>
  );
}
